"use client";
import {
  useTabStore
} from "../__chunks/JZUY7XL6.js";
import "../__chunks/DWZ7E5TJ.js";
import "../__chunks/KZ2S4ZC5.js";
import {
  TabContextProvider
} from "../__chunks/TNITL632.js";
import "../__chunks/UVQLZ7T5.js";
import "../__chunks/TCAGH6BH.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/54MGSIOI.js";
import "../__chunks/DU4D3UCJ.js";
import "../__chunks/RGUP62TM.js";
import "../__chunks/HKOOKEDE.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tab/tab-provider.tsx
import { jsx } from "react/jsx-runtime";
function TabProvider(props = {}) {
  const store = useTabStore(props);
  return /* @__PURE__ */ jsx(TabContextProvider, { value: store, children: props.children });
}
export {
  TabProvider
};
